<div>
  <span style="font-weight: bold; font-size: 30px"> Constituents: {{indexName}}</span>
  <span class="link" style="float: right" (click)="goBack()">Back</span>
</div>
<div>
  <ag-grid-angular
    style="width: 100%;"
    class="ag-theme-balham"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [domLayout]="'autoHeight'"
    (gridReady)="onGridReady($event)"
    [pagination]="true"
    [paginationPageSize]="pagingInfo.pageSize"
    [enableBrowserTooltips]="true">
  </ag-grid-angular>
  <app-pagination-control *ngIf="rowData.length > 0" [input]="this.pagingInfo" (pageChanged)="changePage()"></app-pagination-control>
</div>
